import React from 'react';
import { MethodResult, OptimizeResult, Problem } from '../solver/types';
import MatrixGrid from './MatrixGrid';

interface Props {
  problem: Problem;
  methodName: string;
  balanceNote: string | null;
  maximizeNote: string | null;
  initial: MethodResult;
  optimal: OptimizeResult;
  objectiveLabel: string;
  initialObjective: number;
  optimalObjective: number;
}

// Reporte completo (todos los pasos) pensado para imprimir / exportar a PDF.
const PrintReport: React.FC<Props> = ({
  problem,
  methodName,
  balanceNote,
  maximizeNote,
  initial,
  optimal,
  objectiveLabel,
  initialObjective,
  optimalObjective,
}) => {
  return (
    <div className="print-only">
      <h1>Solución del Problema de Transporte</h1>
      {maximizeNote && <p className="p-note">{maximizeNote}</p>}
      {balanceNote && <p className="p-note">{balanceNote}</p>}

      <h2>1. Solución inicial — {methodName}</h2>
      {initial.steps.map((s, k) => (
        <div className="p-step" key={k}>
          <h3>
            {s.title} — {s.description}
          </h3>
          <MatrixGrid problem={problem} step={s} />
        </div>
      ))}
      <p className="p-total">
        {objectiveLabel} de la solución inicial: <b>{initialObjective}</b>
      </p>

      <h2>2. Optimización — Método MODI</h2>
      {optimal.steps.map((s, k) => (
        <div className="p-step" key={k}>
          <h3>
            {s.title} — {s.description}
          </h3>
          <MatrixGrid problem={problem} step={s} />
          {s.equations && (
            <ul className="p-eqs">
              {s.equations.map((e, i) => (
                <li key={i}>{e}</li>
              ))}
            </ul>
          )}
        </div>
      ))}
      <p className="p-total">
        {objectiveLabel} óptimo: <b>{optimalObjective}</b>
      </p>
    </div>
  );
};

export default PrintReport;
